/**
=========================================================
* Material Dashboard 2 PRO React TS - v1.0.2
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-2-pro-react-ts
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components

// Material Dashboard 2 PRO React TS components
import MDBox from "components/MDBox";

// Material Dashboard 2 PRO React TS examples components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import logo from "assets/images/profile_icon.png";

import { useSelector } from "react-redux";
import { StoreType } from "../types/genericTypes";

import ModalComponent from "components/Modal";
import Footer from "examples/Footer";
import {
  Backdrop,
  Box,
  Button,
  Card,
  CardContent,
  CircularProgress,
  Grid,
  IconButton,
  InputAdornment,
  MenuItem,
  TextField,
  Typography,
} from "@mui/material";
import { useProveedores } from "hooks/useProveedores";
import ProveedorModulo from "components/VistaModulos/ProveedorModulo";
import DetallesProveedor from "components/VistaModulos/DetallesProveedor";
import { FormikProvider } from "formik";
import AddBoxIcon from "@mui/icons-material/AddBox";
import { Spinner } from "react-bootstrap";
import DinamicTable from "components/DinamicTable/DinamicTable";
import { MuiFileInput } from "mui-file-input";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import env from "react-dotenv";
import DisabledByDefaultIcon from "@mui/icons-material/DisabledByDefault";
import { IconUserEdit, IconFilesFilled, IconUsersPlus } from '@tabler/icons-react';

function Proveedores(): JSX.Element {
  const userName = useSelector((state: StoreType) => state?.app?.user?.data?.usuario || null);
  const fotoUser: any = useSelector((state: StoreType) => state?.app?.user?.data?.foto || logo);

  const {
    intl,
    formik,
    procesando,
    isAlertOpen,
    mensajeAlert,
    handleisAlertClose,
    proveedores,
    //crear proveedor
    isAlertOpenCrearProveedor,
    handleisAlertOpenCrearProveedor,
    handleisAlertCloseCrearProveedor,
    getFieldColor,
    procesandoProveedor,
    createEditProveedor,
    proveedoresPaginados,
    page,
    rowsPerPage,
    handleChangePage,
    handleChangeRowsPerPage,
    buscador,
    idUsuario,
    getJefeInmediato,
    jefeInmediato,
    verDetalleProveedor,
    setVerDetalleProveedor,
    isAlertOpenDetalleProveedor,
    handleisAlertOpenDetalleProveedor,
    handleisAlertCloseDetalleProveedor,
    verEditarProveedor,
    setVerEditarProveedor,
    desactivarProveedor,
    activarProveedor,
    //añadir documentos al proveedor
    isAlertOpenDetalleDocumentos,
    handleisAlertOpenDetalleDocumentos,
    handleisAlertCloseDetalleDocumentos,
    subirDocumentoProveedor,
    documentosProveedor,
    getDocumentosFaltantesProveedor,
    idDocumento,
    setIdDocumento,
    handleChangeDocumento,
    archivo,
    setArchivo,
    procesandoSubirDocumento,
    //ver documento individualmente
    handleOpenVistaDocumento,
    handleCloseVistaDocumento,
    isModalVistaDocumento,
    documentoSeleccionado,
    eliminarDocumentoProveedor,
    editarDocumentoProveedor,
    setIdRegistroDocumento,
    idRegistroDocumento,
    areas,
    selectedArea,
    handleChangeAreaTab
  } = useProveedores();

  return (
    <DashboardLayout>
      <MDBox py={2}>
        <Card>
          <CardContent>
            <Grid
              container
              justifyContent="center"
              alignItems="center"
              sx={{ height: "100%", mt: 1 }}
            >
              <Grid xs={12}>
                <Typography variant="h4" sx={{ textAlign: "center" }}>
                  Proveedores
                </Typography>
              </Grid>
              <Grid xs={12}>
                <ProveedorModulo
                  verProveedores={proveedores}
                  proveedoresPaginados={proveedoresPaginados}
                  procesando={procesando}
                  page={page}
                  rowsPerPage={rowsPerPage}
                  handleChangePage={handleChangePage}
                  handleChangeRowsPerPage={handleChangeRowsPerPage}
                  handleisAlertOpenDetalleProveedor={handleisAlertOpenDetalleProveedor}
                  setVerDetalleProveedor={setVerDetalleProveedor}
                  getJefeInmediato={getJefeInmediato}
                  handleisAlertOpenCrearProveedor={handleisAlertOpenCrearProveedor}
                  setVerEditarProveedor={setVerEditarProveedor}
                  desactivarProveedor={desactivarProveedor}
                  activarProveedor={activarProveedor}
                  getDocumentosFaltantesProveedor={getDocumentosFaltantesProveedor}
                  areas={areas}
                  selectedArea={selectedArea}
                  handleChangeAreaTab={handleChangeAreaTab}
                />
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </MDBox>

      {/*<Footer />*/}

      {/* MODAL PARA VER DETALLES DEL PROVEEDOR */}
      <ModalComponent
        esFullScreen
        handleClose={handleisAlertCloseDetalleProveedor}
        isOpen={isAlertOpenDetalleProveedor}
        key={"alerta-detalles-proveedor"}
        {...(verDetalleProveedor?.estatus === 1
          ? {
            actions: [
              {
                title: "Editar proveedor",
                icon: <IconUserEdit stroke={2} />,
                color: "#D4AF37",
                hoverColor: "#a98c2c",
                textColor: "#3D3E3D",
                handleAction: () => {
                  setVerEditarProveedor(verDetalleProveedor);
                  handleisAlertOpenCrearProveedor();
                },
              },
              {
                title: "Documentos",
                icon: <IconFilesFilled stroke={2} />,
                color: "#87CEEB",
                hoverColor: "#6ca4bc",
                textColor: "#041d45",
                handleAction: () => {
                  setVerEditarProveedor(verDetalleProveedor);
                  handleisAlertOpenDetalleDocumentos();
                },
              },
            ],
          }
          : {})}
      >
        {verDetalleProveedor && (
          <Grid container spacing={2} style={{ textAlign: "center" }}>
            <Grid item xs={12}>
              <br />
              <br />
              <DetallesProveedor
                verProveedor={verDetalleProveedor}
                procesandoProveedor={procesandoProveedor}
                usuarioArjion={userName}
                idUsuario={idUsuario}
                jefeInmediato={jefeInmediato}
                handleisAlertOpenCrearProveedor={handleisAlertOpenCrearProveedor}
                setVerEditarProveedor={setVerEditarProveedor}
                handleisAlertOpenDetalleDocumentos={handleisAlertOpenDetalleDocumentos}
              />
            </Grid>
          </Grid>
        )}
      </ModalComponent>
      {/* MODAL PARA AÑADIR DOCUMENTOS AL PROVEEDOR */}
      <ModalComponent
        handleClose={handleisAlertCloseDetalleDocumentos}
        isOpen={isAlertOpenDetalleDocumentos}
        key={"alerta-documentos"}
        size={"xl"}
      >
        {verDetalleProveedor && (
          <Grid container spacing={2} style={{ textAlign: "center" }}>
            <Grid item xs={12}>
              <br />
              <Typography variant="h4" color="primary" gutterBottom sx={{ color: "#344767" }}>
                Documentos de {verDetalleProveedor.nombre_comercial}
              </Typography>
            </Grid>
            <Grid item xs={12} sm={7}>
              <DinamicTable
                key={"tabla"}
                sinExport
                columnsOrder={["nombre", "subido"]}
                data={documentosProveedor}
                esListaDocumentos
                actions
                enAccion={(accion, row) => {
                  if (accion === "ver") {
                    handleOpenVistaDocumento(row);
                  }
                  if (accion === "editar") {
                    setIdDocumento(row.id);
                    setIdRegistroDocumento(row.id_registro);
                  }
                  if (accion === "eliminar") {
                    const datos = {
                      id_documento: row?.id_registro
                    }
                    eliminarDocumentoProveedor(datos);
                  }
                }}
              />
            </Grid>
            <Grid item xs={12} sm={5}>

              <Typography variant="h6" color="primary" gutterBottom mb={4} sx={{ color: "#004c93" }}>
                {idRegistroDocumento ? "Editar documento" : "Registrar nuevo documento"}
              </Typography>
              {idRegistroDocumento ? null : (
                <TextField
                  id="id_documento"
                  select
                  fullWidth
                  label={`${intl.formatMessage({ id: "select_documento" })} *`}
                  variant="outlined"
                  name="documento"
                  value={idDocumento || ""}
                  disabled={!documentosProveedor || documentosProveedor.length === 0}
                  helperText={
                    !documentosProveedor || documentosProveedor.length === 0
                      ? intl.formatMessage({ id: "sin_documentos_registrados" })
                      : ""
                  }
                  onChange={(e) => {
                    const value = Number(e.target.value);
                    setIdDocumento(value);
                  }}
                  InputProps={{
                    style: { padding: "5px" },
                  }}
                >
                  {documentosProveedor
                    ?.filter((id) => id.subido === 0)
                    .map((option) => (
                      <MenuItem key={option.id} value={option.id}>
                        {option.nombre}
                      </MenuItem>
                    ))}
                </TextField>
              )}

              {idDocumento && (
                <Grid container mt={4}>
                  <Grid item xs={12}>
                    <Typography variant="caption" color="text.secondary">
                      Sube tu documento
                    </Typography>
                  </Grid>
                  <Grid item xs={12}>
                    <MuiFileInput
                      value={archivo}
                      onChange={handleChangeDocumento}
                      inputProps={{ accept: ".pdf" }}
                      hideSizeText
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <PictureAsPdfIcon fontSize="medium" />
                          </InputAdornment>
                        ),
                        endAdornment: archivo && (
                          <InputAdornment position="end">
                            <Button
                              sx={{
                                color: "#fff",
                                background: "#eb2fa5",
                                fontSize: "0.75rem",
                                padding: "6px 8px",
                                margin: "0",
                              }}
                              size="small"
                              variant="contained"
                              onClick={(e: any) => {
                                if (idRegistroDocumento) {
                                  const datos = {
                                    id: idRegistroDocumento,
                                    id_usuario: idUsuario,
                                    archivo: archivo,
                                  };
                                  editarDocumentoProveedor(datos);
                                } else {
                                  const datos = {
                                    id_proveedor: verDetalleProveedor?.id,
                                    id_documento: idDocumento,
                                    id_usuario: idUsuario,
                                    archivo: archivo,
                                  };
                                  subirDocumentoProveedor(datos);
                                }
                              }}
                            >
                              {procesandoSubirDocumento ? (
                                <>
                                  <Spinner
                                    as="span"
                                    animation="border"
                                    size="sm"
                                    role="status"
                                    aria-hidden="true"
                                  />
                                  Subiendo...{" "}
                                </>
                              ) : (
                                idRegistroDocumento ? intl.formatMessage({ id: "editar_documento" }) : intl.formatMessage({ id: "subir_documento" })
                              )}
                            </Button>
                          </InputAdornment>
                        ),
                      }}
                      placeholder={`${intl.formatMessage({
                        id: "subir_documento_placeholder",
                      })}`}
                    />
                  </Grid>
                </Grid>
              )}
            </Grid>
          </Grid>
        )}
      </ModalComponent>
      {/* MODAL PARA AÑADIR PROVEEDOR */}
      <ModalComponent
        handleClose={handleisAlertCloseCrearProveedor}
        isOpen={isAlertOpenCrearProveedor}
        key={"alerta-crear-Inventario"}
        titleButtonAction={verEditarProveedor ? "Editar" : "Añadir"}
        iconButtonAction={verEditarProveedor ? <IconUserEdit stroke={2} /> : <IconUsersPlus stroke={2} />}
        disabledButtonAction={!verEditarProveedor && !formik.isValid}
        handleAction={() => {
          const datos = {
            ...(verEditarProveedor && { id_proveedor: verEditarProveedor?.id }),
            codigo: formik.values.codigo,
            razon_social: formik.values.razon_social,
            nombre_comercial: formik.values.nombre_comercial,
            direccion: formik.values.direccion,
            contacto: formik.values.contacto,
            giro: formik.values.giro,
            rfc: formik.values.rfc,
            importe_credito: formik.values.importe_credito,
            dias_credito: formik.values.dias_credito,
            tiempo_entrega: formik.values.tiempo_entrega,
            correo: formik.values.correo,
            telefono: formik.values.telefono,
            id_usuario: idUsuario,
          };
          createEditProveedor(datos);
        }}
        colorAction={verEditarProveedor ? "#D4AF37" : "#50C878"}
        hoverColorAction={verEditarProveedor ? "#a98c2c" : "#40a060"}
        textColorAction={verEditarProveedor ? "#3D3E3D" : "#000000"}
      >
        <FormikProvider value={formik!}>
          <Grid container spacing={2} style={{ textAlign: "center" }}>
            <Grid item xs={12} md={12} mt={2}>
              <Typography variant="h5" color="primary" gutterBottom sx={{ color: "#004c93", textAlign: "center" }}>
                {verEditarProveedor ? "Editar proveedor" : "Registrar Proveedor"}
              </Typography>
            </Grid>
            <br />
            <Grid item xs={12} sm={6}>
              <TextField
                id="codigo"
                fullWidth
                label={`${intl.formatMessage({ id: "input_codigo" })}`}
                variant="outlined"
                name="codigo"
                value={formik.values.codigo || ""}
                onChange={(e) => {
                  const value = e.target.value;
                  formik.setFieldValue("codigo", value);
                }}
                onBlur={formik.handleBlur}
                error={formik.touched.codigo && Boolean(formik.errors.codigo)}
                helperText={formik.touched.codigo && formik.errors.codigo}
                sx={{
                  "& .MuiInputLabel-root": {
                    color: getFieldColor("codigo"),
                  },
                  "& .MuiInput-underline:after": {
                    borderBottomColor: getFieldColor("codigo"),
                  },
                  "& .MuiInput-underline:before": {
                    borderBottomColor: getFieldColor("codigo"),
                  },
                  "& .MuiInputBase-input": {
                    color: getFieldColor("codigo"),
                  },
                }}
              />
            </Grid>
            <Grid item xs={12} sm={6} sx={{ position: "relative" }}>
              <TextField
                id="razon_social"
                fullWidth
                label={`${intl.formatMessage({ id: "input_razon_social" })}`}
                variant="outlined"
                name="razon_social"
                value={formik.values.razon_social || ""}
                onChange={(e) => {
                  const value = e.target.value;
                  formik.setFieldValue("razon_social", value);
                }}
                onBlur={formik.handleBlur}
                error={formik.touched.razon_social && Boolean(formik.errors.razon_social)}
                helperText={formik.touched.razon_social && formik.errors.razon_social}
                sx={{
                  "& .MuiInputLabel-root": {
                    color: getFieldColor("razon_social"),
                  },
                  "& .MuiInput-underline:after": {
                    borderBottomColor: getFieldColor("razon_social"),
                  },
                  "& .MuiInput-underline:before": {
                    borderBottomColor: getFieldColor("razon_social"),
                  },
                  "& .MuiInputBase-input": {
                    color: getFieldColor("razon_social"),
                  },
                }}
              />
            </Grid>
            <Grid item xs={12} sm={6} sx={{ position: "relative" }}>
              <TextField
                id="nombre_comercial"
                fullWidth
                label={`${intl.formatMessage({ id: "input_nombre_comercial" })}`}
                variant="outlined"
                name="nombre_comercial"
                value={formik.values.nombre_comercial || ""}
                onChange={(e) => {
                  const value = e.target.value;
                  formik.setFieldValue("nombre_comercial", value);
                }}
                onBlur={formik.handleBlur}
                error={formik.touched.nombre_comercial && Boolean(formik.errors.nombre_comercial)}
                helperText={formik.touched.nombre_comercial && formik.errors.nombre_comercial}
                sx={{
                  "& .MuiInputLabel-root": {
                    color: getFieldColor("nombre_comercial"),
                  },
                  "& .MuiInput-underline:after": {
                    borderBottomColor: getFieldColor("nombre_comercial"),
                  },
                  "& .MuiInput-underline:before": {
                    borderBottomColor: getFieldColor("nombre_comercial"),
                  },
                  "& .MuiInputBase-input": {
                    color: getFieldColor("nombre_comercial"),
                  },
                }}
              />
            </Grid>
            <Grid item xs={12} sm={6} sx={{ position: "relative" }}>
              <TextField
                id="direccion"
                fullWidth
                label={`${intl.formatMessage({ id: "input_direccion" })}`}
                variant="outlined"
                name="direccion"
                value={formik.values.direccion || ""}
                onChange={(e) => {
                  const value = e.target.value;
                  formik.setFieldValue("direccion", value);
                }}
                onBlur={formik.handleBlur}
                error={formik.touched.direccion && Boolean(formik.errors.direccion)}
                helperText={formik.touched.direccion && formik.errors.direccion}
                sx={{
                  "& .MuiInputLabel-root": {
                    color: getFieldColor("direccion"),
                  },
                  "& .MuiInput-underline:after": {
                    borderBottomColor: getFieldColor("direccion"),
                  },
                  "& .MuiInput-underline:before": {
                    borderBottomColor: getFieldColor("direccion"),
                  },
                  "& .MuiInputBase-input": {
                    color: getFieldColor("direccion"),
                  },
                }}
              />
            </Grid>
            <Grid item xs={12} sm={6} sx={{ position: "relative" }}>
              <TextField
                id="contacto"
                fullWidth
                label={`${intl.formatMessage({ id: "input_contacto" })}`}
                variant="outlined"
                name="contacto"
                value={formik.values.contacto || ""}
                onChange={(e) => {
                  const value = e.target.value;
                  formik.setFieldValue("contacto", value);
                }}
                onBlur={formik.handleBlur}
                error={formik.touched.contacto && Boolean(formik.errors.contacto)}
                helperText={formik.touched.contacto && formik.errors.contacto}
                sx={{
                  "& .MuiInputLabel-root": {
                    color: getFieldColor("contacto"),
                  },
                  "& .MuiInput-underline:after": {
                    borderBottomColor: getFieldColor("contacto"),
                  },
                  "& .MuiInput-underline:before": {
                    borderBottomColor: getFieldColor("contacto"),
                  },
                  "& .MuiInputBase-input": {
                    color: getFieldColor("contacto"),
                  },
                }}
              />
            </Grid>
            <Grid item xs={12} sm={6} sx={{ position: "relative" }}>
              <TextField
                id="giro"
                fullWidth
                label={`${intl.formatMessage({ id: "input_giro" })}`}
                variant="outlined"
                name="giro"
                value={formik.values.giro || ""}
                onChange={(e) => {
                  const value = e.target.value;
                  formik.setFieldValue("giro", value);
                }}
                onBlur={formik.handleBlur}
                error={formik.touched.giro && Boolean(formik.errors.giro)}
                helperText={formik.touched.giro && formik.errors.giro}
                sx={{
                  "& .MuiInputLabel-root": {
                    color: getFieldColor("giro"),
                  },
                  "& .MuiInput-underline:after": {
                    borderBottomColor: getFieldColor("giro"),
                  },
                  "& .MuiInput-underline:before": {
                    borderBottomColor: getFieldColor("giro"),
                  },
                  "& .MuiInputBase-input": {
                    color: getFieldColor("giro"),
                  },
                }}
              />
            </Grid>
            <Grid item xs={12} sm={4} sx={{ position: "relative" }}>
              <TextField
                id="importe_credito"
                fullWidth
                label={`${intl.formatMessage({ id: "input_importe_credito" })}`}
                variant="outlined"
                name="importe_credito"
                type="number"
                value={formik.values.importe_credito || ""}
                onChange={(e) => {
                  const value = e.target.value;
                  formik.setFieldValue("importe_credito", value);
                }}
                onBlur={formik.handleBlur}
                error={formik.touched.importe_credito && Boolean(formik.errors.importe_credito)}
                helperText={formik.touched.importe_credito && formik.errors.importe_credito}
                sx={{
                  "& .MuiInputLabel-root": {
                    color: getFieldColor("importe_credito"),
                  },
                  "& .MuiInput-underline:after": {
                    borderBottomColor: getFieldColor("importe_credito"),
                  },
                  "& .MuiInput-underline:before": {
                    borderBottomColor: getFieldColor("importe_credito"),
                  },
                  "& .MuiInputBase-input": {
                    color: getFieldColor("importe_credito"),
                  },
                }}
              />
            </Grid>
            <Grid item xs={12} sm={4} sx={{ position: "relative" }}>
              <TextField
                id="dias_credito"
                fullWidth
                label={`${intl.formatMessage({ id: "input_dias_credito" })}`}
                variant="outlined"
                name="dias_credito"
                type="number"
                value={formik.values.dias_credito || ""}
                onChange={(e) => {
                  const value = e.target.value;
                  formik.setFieldValue("dias_credito", value);
                }}
                onBlur={formik.handleBlur}
                error={formik.touched.dias_credito && Boolean(formik.errors.dias_credito)}
                helperText={formik.touched.dias_credito && formik.errors.dias_credito}
                sx={{
                  "& .MuiInputLabel-root": {
                    color: getFieldColor("dias_credito"),
                  },
                  "& .MuiInput-underline:after": {
                    borderBottomColor: getFieldColor("dias_credito"),
                  },
                  "& .MuiInput-underline:before": {
                    borderBottomColor: getFieldColor("dias_credito"),
                  },
                  "& .MuiInputBase-input": {
                    color: getFieldColor("dias_credito"),
                  },
                }}
              />
            </Grid>
            <Grid item xs={12} sm={4} sx={{ position: "relative" }}>
              <TextField
                id="tiempo_entrega"
                fullWidth
                label={`${intl.formatMessage({ id: "input_tiempo_entrega" })}`}
                variant="outlined"
                name="tiempo_entrega"
                type="number"
                value={formik.values.tiempo_entrega || ""}
                onChange={(e) => {
                  const value = e.target.value;
                  formik.setFieldValue("tiempo_entrega", value);
                }}
                onBlur={formik.handleBlur}
                error={formik.touched.tiempo_entrega && Boolean(formik.errors.tiempo_entrega)}
                helperText={formik.touched.tiempo_entrega && formik.errors.tiempo_entrega}
                sx={{
                  "& .MuiInputLabel-root": {
                    color: getFieldColor("tiempo_entrega"),
                  },
                  "& .MuiInput-underline:after": {
                    borderBottomColor: getFieldColor("tiempo_entrega"),
                  },
                  "& .MuiInput-underline:before": {
                    borderBottomColor: getFieldColor("tiempo_entrega"),
                  },
                  "& .MuiInputBase-input": {
                    color: getFieldColor("tiempo_entrega"),
                  },
                }}
              />
            </Grid>
            <Grid item xs={12} sm={4} sx={{ position: "relative" }}>
              <TextField
                id="correo"
                fullWidth
                label={`${intl.formatMessage({ id: "input_correo" })}`}
                variant="outlined"
                name="correo"
                value={formik.values.correo || ""}
                onChange={(e) => {
                  const value = e.target.value;
                  formik.setFieldValue("correo", value);
                }}
                onBlur={formik.handleBlur}
                error={formik.touched.correo && Boolean(formik.errors.correo)}
                helperText={formik.touched.correo && formik.errors.correo}
                sx={{
                  "& .MuiInputLabel-root": {
                    color: getFieldColor("correo"),
                  },
                  "& .MuiInput-underline:after": {
                    borderBottomColor: getFieldColor("correo"),
                  },
                  "& .MuiInput-underline:before": {
                    borderBottomColor: getFieldColor("correo"),
                  },
                  "& .MuiInputBase-input": {
                    color: getFieldColor("correo"),
                  },
                }}
              />
            </Grid>
            <Grid item xs={12} sm={4} sx={{ position: "relative" }}>
              <TextField
                id="telefono"
                fullWidth
                label={`${intl.formatMessage({ id: "input_telefono" })}`}
                variant="outlined"
                name="telefono"
                type="number"
                value={formik.values.telefono || ""}
                onChange={(e) => {
                  const value = e.target.value;
                  formik.setFieldValue("telefono", value);
                }}
                onBlur={formik.handleBlur}
                error={formik.touched.telefono && Boolean(formik.errors.telefono)}
                helperText={formik.touched.telefono && formik.errors.telefono}
                sx={{
                  "& .MuiInputLabel-root": {
                    color: getFieldColor("telefono"),
                  },
                  "& .MuiInput-underline:after": {
                    borderBottomColor: getFieldColor("telefono"),
                  },
                  "& .MuiInput-underline:before": {
                    borderBottomColor: getFieldColor("telefono"),
                  },
                  "& .MuiInputBase-input": {
                    color: getFieldColor("telefono"),
                  },
                }}
              />
            </Grid>
            <Grid item xs={12} sm={4} sx={{ position: "relative" }}>
              <TextField
                id="rfc"
                fullWidth
                label={`${intl.formatMessage({ id: "input_rfc" })}`}
                variant="outlined"
                name="rfc"
                value={formik.values.rfc || ""}
                onChange={(e) => {
                  const value = e.target.value;
                  formik.setFieldValue("rfc", value);
                }}
                onBlur={formik.handleBlur}
                error={formik.touched.rfc && Boolean(formik.errors.rfc)}
                helperText={formik.touched.rfc && formik.errors.rfc}
                sx={{
                  "& .MuiInputLabel-root": {
                    color: getFieldColor("rfc"),
                  },
                  "& .MuiInput-underline:after": {
                    borderBottomColor: getFieldColor("rfc"),
                  },
                  "& .MuiInput-underline:before": {
                    borderBottomColor: getFieldColor("rfc"),
                  },
                  "& .MuiInputBase-input": {
                    color: getFieldColor("rfc"),
                  },
                }}
              />
            </Grid>
          </Grid>
        </FormikProvider>
      </ModalComponent>
      {/* MODAL PARA VER DOCUMENTO DE PROVEEDOR INDIVIDUALMENTE */}
      <ModalComponent
        handleClose={handleCloseVistaDocumento}
        isOpen={isModalVistaDocumento}
        key="vista-documento-individual"
      >
        {documentoSeleccionado && documentoSeleccionado.nombre_documento ? (
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <MDBox display="flex" justifyContent="space-between" alignItems="center" mb={2}>
                <Typography variant="h5">{documentoSeleccionado.nombre_documento}</Typography>
                <IconButton onClick={handleCloseVistaDocumento} size="large" color="error">
                  <DisabledByDefaultIcon />
                </IconButton>
              </MDBox>
            </Grid>
            <Grid item xs={12}>
              <MDBox display="flex" justifyContent="center" alignItems="center" minHeight="60vh">
                <iframe
                  src={`${env.API_URL_ASSETS}${documentoSeleccionado.url_archivo}`}
                  style={{
                    width: "100%",
                    height: "70vh",
                    border: "none",
                    borderRadius: "8px",
                  }}
                  title="Vista documento"
                />
              </MDBox>
            </Grid>
            <Grid item xs={12}>
              <MDBox display="flex" justifyContent="flex-end" gap={2}>
                <Button
                  sx={{ color: "#fff", background: "#084d6e" }}
                  variant="contained"
                  component="a"
                  href={`${env.API_URL_ASSETS}${documentoSeleccionado.url_archivo}`}
                  download={documentoSeleccionado.nombre_documento}
                  target="_blank"
                >
                  Descargar
                </Button>
              </MDBox>
            </Grid>
          </Grid>
        ) : (
          <Box sx={{ textAlign: "center", py: 2 }}>
            <Typography variant="h6" color="text.secondary">
              {intl.formatMessage({ id: "no_hay_datos_registrados" })}
            </Typography>
          </Box>
        )}
      </ModalComponent>
      <Backdrop
        sx={(theme) => ({ color: "#fff", zIndex: theme.zIndex.drawer + 1 })}
        open={procesando}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <ModalComponent handleClose={handleisAlertClose} isOpen={isAlertOpen} key={"alerta"}>
        <Grid container spacing={2} style={{ textAlign: "center" }}>
          <Grid item xs={12}>
            <br />
            <br />
            <p>{mensajeAlert}</p>
          </Grid>
        </Grid>
      </ModalComponent>
    </DashboardLayout >
  );
}

export default Proveedores;
